const SWIGGY_MONEY_INFO = "sm_inf";

export const SWIGGY_MONEY_INFO_TEST_IDS = {
    MESSAGE: `${SWIGGY_MONEY_INFO}_message`,
    CTA: `${SWIGGY_MONEY_INFO}_cta`,
    HALF_CARD_CONTAINER: `${SWIGGY_MONEY_INFO}_hf_container`,
    HALF_CARD_CLOSE_BUTTON: `${SWIGGY_MONEY_INFO}_hf_close_button`,
};
